import properties from './properties.js';

export default {
  en: {
    properties: properties.en,
    contactField: 'Contact property | Contact properties',
    persons: {
      title: 'Persons',
      description: 'Visualize and manage person contacts',
    },
    companies: {
      title: 'Companies',
      description: 'Visualize and manage companies contacts',
    },
    filters: {
      label: 'Search a contact by all fields',
    },
  },
  es: {
    properties: properties.es,
    contactField: 'Propiedad de contacto | Propiedades de contacto',
    persons: {
      title: 'Personas',
      description: 'Visualizar y gestionar contactos de personas',
    },
    companies: {
      title: 'Empresas',
      description: 'Visualizar y gestionar contactos de empresas',
    },
    filters: {
      label: 'Búsqueda de contacto por todos los campos',
    },
  },
  fr: {
    properties: properties.fr,
    contactField: 'Propriété de contact | Propriétés de contact',
    persons: {
      title: 'Personnes',
      description: 'Visualiser et gérer les contacts des personnes',
    },
    companies: {
      title: 'Entreprises',
      description: 'Visualiser et gérer les contacts des entreprises',
    },
    filters: {
      label: 'Rechercher un contact par tous les champs',
    },
  },
}
